import type { FaireThemeEntity } from "../../entity_types/theme";

export const everyday_18k_gold_glow: FaireThemeEntity = {
  token: "everyday-18k-gold-glow",
  type: "theme",
  name: "Everyday 18K Gold Glow",
  description: "Elegant, water-resistant, non-tarnish jewelry offering a high-end look at an accessible price point.",
  teaser: "Low-maintenance gold pieces your beauty clients wear every day.",
  detail: "Your patrons appreciate low-maintenance, hypoallergenic accessories. These 18K gold-plated pieces fit a boutique focused on clothing and style, with strong preference for the knot necklace and chain fringe earrings.",
  bgColor: "#D6E0F0",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_ut3tbs6mrw",
    "p_3pcekmbkc4",
    "p_m8ybpjvqmq",
    "p_tpf2apke3k",
    "p_zxurf3jtrh",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
